var page = 1;

$(function () {
    var columnid = $(".list").attr("dataid");
    var columns = getColumnIndex(columnid);
    if (columns) {
        $(".column-index").html(columns);
    }
    getContents(columnid);
    // getRecommends();
    getHots();

    $(".home-recommends .more").on("click", function () {
        location.href = ROOT + "/recommends";
    });

    $(".list .more").on("click", function () {
        var id = $(".list").attr("dataid");
        getContents(id);
    });
});

function getContents(id) {
    if (!id) return;

    $.ajax({
        type: "get",
        async: false,
        url: ROOT + "/home/contents?id=" + id + "&page=" + page + "&size=10",
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data == "") {
                return;
            }
            if (data.message !== undefined) {
                alert("操作失败:" + data.message);
                return;
            }
            if (data.data === undefined) {
                alert("操作失败");
                return;
            }
            var newlist = toListHtml(data);

            $(".list .newsItems").append(newlist);
            page++;

            if (data.data.length < 10) {
                $(".list .more").addClass("no-more");
            }

            if ($(".newsItem").length == 0)
                $(".list").html(
                    '<div style="text-align: center;">暂无内容</div>'
                );
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined)
                alert("获取列表失败:" + data.message);
            else alert("获取列表失败");
        },
    });
}

function toListHtml(data) {
    var newlist = "";
    for (var i = 0; i < data.data.length; i++) {
        var info = data.data[i];
        if (
            info.thumbnail_urls === undefined ||
            info.thumbnail_urls == null ||
            info.thumbnail_urls == ""
        )
            info.thumbnail_urls = [];

        var bottominfo = "";
        bottominfo += '<div class="news_info">';
        /* if (info.author_avatar_url) {
            bottominfo += '<div class="user">';
            bottominfo += '<img src="' + info.author_avatar_url + '?w=18&h=18&s=3' + '"/>' + info.author_nickname;
            bottominfo += '</div>';
        } else
            bottominfo += '<div class="user"><img src="' + ROOT + '/static/images/no-avatar.png"/>' + info.author_nickname + '</div>'; */
        // bottominfo += '<div class="user">' + info.author_nickname + '</div>';
        bottominfo += '<div class="time">' + info.publish_time + "</div>";
        bottominfo += '<div class="reply">';
        // if (info.comment_count > 0)
        //     bottominfo += '<div class="reply_count">' + info.comment_count + '评论</div>';
        // if (info.view_count > 0)
        //     bottominfo += '<div class="reply_count">' + info.view_count + '浏览</div>';
        bottominfo += "</div>";
        // if (info.source)
        //     bottominfo += '<div class="source">来源: ' + info.source + '</div>';
        bottominfo += "</div>";

        newlist += '<div class="newsItem">';
        // 只显示有图和无图两种情况
        if (
            info.list_item_mode == 0 ||
            info.thumbnail_urls.length == 0 ||
            !info.thumbnail_urls[0]
        ) {
            // 无图
            newlist += '<div class="newsInfo noPic">';
            newlist += '<div class="news_body">';
            newlist +=
                '<a class="news_title" href="' +
                info.url +
                '" target="_blank">' +
                info.title +
                "</a>";
            newlist += '<div class="news_content">';
            if (info.summary) newlist += info.summary;
            newlist += "</div>";
            newlist += "</div>";
            newlist += bottominfo;
            newlist += "</div>";
        } else {
            newlist += '<div class="newsPicture">';
            newlist += '<a href="' + info.url + '" target="_blank">';
            newlist +=
                '<img src="' +
                info.thumbnail_urls[0] +
                "?w=200&h=150&s=3" +
                '"/>';
            newlist += "</a>";
            newlist += "</div>";
            newlist += '<div class="newsInfo">';

            newlist += '<div class="news_body">';
            newlist +=
                '<a class="news_title" href="' +
                info.url +
                '" target="_blank">' +
                info.title +
                "</a>";
            newlist += '<div class="news_content">';
            if (info.summary) newlist += info.summary;
            newlist += "</div>";
            newlist += "</div>";
            newlist += bottominfo;
            newlist += "</div>";
        }
        newlist += "</div>";
        newlist += '<div class="dividing-line"></div>';
    }
    return newlist;
}

function getRecommends() {
    $.ajax({
        type: "get",
        async: false,
        url: ROOT + "/home/contents?id=recommend&page=" + page + "&size=5",
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (data == "") return;
            if (data.message !== undefined) {
                return;
            }
            if (data.data === undefined) {
                return;
            }
            var newlist = "";
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];
                newlist += '<div class="recommends-item">';
                newlist +=
                    '<div class="recommends-item-title"><a href="' +
                    info.url +
                    '" target="_blank">' +
                    info.title +
                    "</a></div>";
                newlist +=
                    '<div class="recommends-item-time">' +
                    info.publish_time +
                    "</div>";
                newlist += "</div>";
            }

            $(".recommend .recommends-items").html(newlist);
        },
        error: function (data) {
            console.log(data);
        },
    });
}

function getHots() {
    $.ajax({
        type: "get",
        async: false,
        url: ROOT + "/home/hots",
        data: null,
        contentType: "application/json",
        dataType: "json",
        success: function (data) {
            if (!data || data.message !== undefined) {
                console.log(data);
                return;
            }
            var newlist = "";
            for (var i = 0; i < data.length; i++) {
                var info = data[i];
                if (i < 3) {
                    newlist += '<div class="hots-item top3">';
                } else {
                    newlist += '<div class="hots-item">';
                }
                newlist +=
                    '<div class="hots-item-number">' + (i + 1) + "</div>";
                newlist +=
                    '<div class="hots-item-title"><a href="' +
                    info.url +
                    '" target="_blank">' +
                    info.title +
                    "</a></div>";
                newlist += "</div>";
            }

            $(".hots .hots-list").html(newlist);
        },
        error: function (data) {
            console.log(data);
        },
    });
}
